//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
export class BaseEntity {
    identifier;
    createdOn;
    modifiedOn;
    constructor() {
        this.identifier = "";
        this.createdOn = null;
        this.modifiedOn = null;
    }
}
export class LocalizedEntity extends BaseEntity {
    key;
    values;
    constructor() {
        super();
        this.key = "";
        this.values = {};
    }
}
export class AutoDictionaryOfString {
    item;
    constructor() {
        this.item = "";
    }
}
export class AppConfig extends BaseEntity {
    showDeliveryOptions;
    customerSources;
    clusters;
    customerStates;
    qualifichePianoCarriera;
    qualificheCommerciali;
    acquistaBannerUrl;
    bannerInizialeUrl;
    bannerInizialeImageUrl;
    marketingReferralImageUrl;
    loginImageUrl;
    loginImageLink;
    localizationConfiguration;
    constructor() {
        super();
        this.showDeliveryOptions = false;
        this.customerSources = [];
        this.clusters = [];
        this.customerStates = [];
        this.qualifichePianoCarriera = [];
        this.qualificheCommerciali = [];
        this.acquistaBannerUrl = "";
        this.bannerInizialeUrl = "";
        this.bannerInizialeImageUrl = "";
        this.marketingReferralImageUrl = "";
        this.loginImageUrl = "";
        this.loginImageLink = "";
        this.localizationConfiguration = new LocalizationConfiguration();
    }
}
export class QualificaPianoCarrieraConfig {
    name;
    daysNeeded;
    constructor() {
        this.name = "";
        this.daysNeeded = null;
    }
}
export class LocalizationConfiguration {
    defaultLanguage;
    supportedLanguages;
    enabledLanguages;
    constructor() {
        this.defaultLanguage = "";
        this.supportedLanguages = [];
        this.enabledLanguages = [];
    }
}
export class SwaggerFillerDrawingElements {
    wallSegment;
    window;
    image;
    polyline;
    constructor() {
        this.wallSegment = new WallSegment();
        this.window = new Window();
        this.image = new Image();
        this.polyline = new Polyline();
    }
}
export class DrawingElement {
    id;
    name;
    x;
    y;
    rotation;
    color;
    isStructural;
    type;
    constructor() {
        this.id = null;
        this.name = "";
        this.x = null;
        this.y = null;
        this.rotation = null;
        this.color = "";
        this.isStructural = false;
        this.type = "";
    }
}
export class WallSegment extends DrawingElement {
    coordinateStart;
    coordinateEnd;
    coordinateArc;
    thickness;
    origin;
    constructor() {
        super();
        this.coordinateStart = new PointCoordinates();
        this.coordinateEnd = new PointCoordinates();
        this.coordinateArc = new PointCoordinates();
        this.thickness = null;
        this.origin = "";
    }
}
export class PointCoordinates {
    x;
    y;
    constructor() {
        this.x = null;
        this.y = null;
    }
}
export class Window extends DrawingElement {
    pathReferenceId;
    width;
    height;
    constructor() {
        super();
        this.pathReferenceId = null;
        this.width = null;
        this.height = null;
    }
}
export class Image extends DrawingElement {
    imagePath;
    width;
    height;
    constructor() {
        super();
        this.imagePath = "";
        this.width = null;
        this.height = null;
    }
}
export class Polyline extends DrawingElement {
    points;
    constructor() {
        super();
        this.points = [];
    }
}
export class TablePagedResultOfCreditTransaction {
    data;
    count;
    pageNumber;
    perPage;
    constructor() {
        this.data = [];
        this.count = null;
        this.pageNumber = null;
        this.perPage = null;
    }
}
export class CreditTransaction extends BaseEntity {
    price;
    credits;
    note;
    customer;
    task;
    portafoglioIdentifier;
    commercialeData;
    constructor() {
        super();
        this.price = null;
        this.credits = new CreditsDictionary();
        this.note = "";
        this.customer = new NameIdentifier();
        this.task = new NameIdentifier();
        this.portafoglioIdentifier = "";
        this.commercialeData = new CommercialeData();
    }
}
export class CreditsDictionary {
    item;
    constructor() {
        this.item = null;
    }
}
export class NameIdentifier {
    name;
    identifier;
    constructor() {
        this.name = "";
        this.identifier = "";
    }
}
export class CommercialeData {
    commerciale;
    isFirstBuy;
    paidAmount;
    constructor() {
        this.commerciale = new NameIdentifier();
        this.isFirstBuy = false;
        this.paidAmount = null;
    }
}
export class BaseListFilterVm {
    pageNumber;
    perPage;
    sortBy;
    constructor() {
        this.pageNumber = null;
        this.perPage = null;
        this.sortBy = new SortByParameter();
    }
}
export class CreditTransactionListFilterVm extends BaseListFilterVm {
    createdOnFrom;
    createdOnTo;
    priceFrom;
    priceTo;
    note;
    customer;
    task;
    commerciale;
    isFirstBuy;
    paidAmountFrom;
    paidAmountTo;
    constructor() {
        super();
        this.createdOnFrom = null;
        this.createdOnTo = null;
        this.priceFrom = null;
        this.priceTo = null;
        this.note = "";
        this.customer = "";
        this.task = "";
        this.commerciale = "";
        this.isFirstBuy = null;
        this.paidAmountFrom = null;
        this.paidAmountTo = null;
    }
}
export class SortByParameter {
    propertyName;
    ascending;
    constructor() {
        this.propertyName = "";
        this.ascending = false;
    }
}
export class RiepilogoTransactionsCommercialiVm {
    commerciale;
    totaleTrans;
    quantitaFirstBuy;
    totaleCompenso;
    constructor() {
        this.commerciale = new NameIdentifier();
        this.totaleTrans = null;
        this.quantitaFirstBuy = null;
        this.totaleCompenso = null;
    }
}
export class CreditTransactionVm {
    identifier;
    date;
    price;
    credits;
    note;
    customer;
    commercialeData;
    task;
    constructor() {
        this.identifier = "";
        this.date = null;
        this.price = null;
        this.credits = new CreditsDictionary();
        this.note = "";
        this.customer = "";
        this.commercialeData = new CommercialeData();
        this.task = "";
    }
}
export class CustomerCluster extends BaseEntity {
    name;
    multipliers;
    adders;
    constructor() {
        super();
        this.name = "";
        this.multipliers = new DiscountDictionary();
        this.adders = new DiscountDictionary();
    }
}
export class DiscountDictionary {
    item;
    constructor() {
        this.item = null;
    }
}
export class Customer extends BaseEntity {
    name;
    surname;
    completeName;
    agenzia;
    email;
    contactEmail;
    password;
    note;
    noteInterne;
    address;
    rating;
    avatarUrl;
    partitaIva;
    codiceDestinatario;
    pec;
    recensioneLasciata;
    telefono;
    cellulare;
    clienteOn;
    nonPiuClienteOn;
    richiestaPlanimetriaGratuitaOn;
    source;
    importanza;
    lastConnected;
    officeIdentifier;
    resetPasswordToken;
    isAccountPadre;
    clienteParentIdentifier;
    cluster;
    lastTaskOn;
    lastContact;
    freezedOn;
    state;
    activities;
    scadenza;
    stripeId;
    allegatiInterni;
    metaData;
    preferredCulture;
    commercialeIdentifier;
    constructor() {
        super();
        this.name = "";
        this.surname = "";
        this.completeName = "";
        this.agenzia = "";
        this.email = "";
        this.contactEmail = "";
        this.password = "";
        this.note = "";
        this.noteInterne = "";
        this.address = new Address();
        this.rating = null;
        this.avatarUrl = "";
        this.partitaIva = "";
        this.codiceDestinatario = "";
        this.pec = "";
        this.recensioneLasciata = false;
        this.telefono = "";
        this.cellulare = "";
        this.clienteOn = null;
        this.nonPiuClienteOn = null;
        this.richiestaPlanimetriaGratuitaOn = null;
        this.source = "";
        this.importanza = null;
        this.lastConnected = null;
        this.officeIdentifier = "";
        this.resetPasswordToken = "";
        this.isAccountPadre = false;
        this.clienteParentIdentifier = "";
        this.cluster = "";
        this.lastTaskOn = null;
        this.lastContact = null;
        this.freezedOn = null;
        this.state = "";
        this.activities = [];
        this.scadenza = null;
        this.stripeId = "";
        this.allegatiInterni = [];
        this.metaData = {};
        this.preferredCulture = "";
        this.commercialeIdentifier = "";
    }
}
export class Address {
    latitude;
    longitude;
    typedAddress;
    constructor() {
        this.latitude = null;
        this.longitude = null;
        this.typedAddress = "";
    }
}
export class CustomerActivity {
    postedBy;
    postedOn;
    text;
    constructor() {
        this.postedBy = new NameIdentifier();
        this.postedOn = null;
        this.text = "";
    }
}
export class Attachment2 {
    fileIdentifier;
    fileName;
    mimeType;
    thumbnailUrl;
    publicUrl;
    storagePath;
    constructor() {
        this.fileIdentifier = "";
        this.fileName = "";
        this.mimeType = "";
        this.thumbnailUrl = "";
        this.publicUrl = "";
        this.storagePath = "";
    }
}
export class Attachment extends Attachment2 {
    attachedOn;
    constructor() {
        super();
        this.attachedOn = null;
    }
}
export class MailSent extends BaseEntity {
    mailTemplateName;
    sender;
    recipient;
    subject;
    text;
    constructor() {
        super();
        this.mailTemplateName = "";
        this.sender = "";
        this.recipient = "";
        this.subject = "";
        this.text = "";
    }
}
export class GetCustomerForTrelloFilterVm {
    name;
    officeIdentifier;
    showClienti;
    showNonClienti;
    stelleFilter;
    clusterFilter;
    state;
    sortByScadenza;
    onlyFreezed;
    constructor() {
        this.name = "";
        this.officeIdentifier = "";
        this.showClienti = false;
        this.showNonClienti = false;
        this.stelleFilter = [];
        this.clusterFilter = [];
        this.state = "";
        this.sortByScadenza = null;
        this.onlyFreezed = false;
    }
}
export class StellineStatVm {
    zeroStelle;
    unaStella;
    dueStelle;
    treStelle;
    quattroStelle;
    cinqueStelle;
    totaleClienti;
    totaleLead;
    constructor() {
        this.zeroStelle = new StellineStatRowDetailsVm();
        this.unaStella = new StellineStatRowDetailsVm();
        this.dueStelle = new StellineStatRowDetailsVm();
        this.treStelle = new StellineStatRowDetailsVm();
        this.quattroStelle = new StellineStatRowDetailsVm();
        this.cinqueStelle = new StellineStatRowDetailsVm();
        this.totaleClienti = new StellineStatRowDetailsVm();
        this.totaleLead = new StellineStatRowDetailsVm();
    }
}
export class StellineStatRowDetailsVm {
    totale;
    freezati;
    nonPiuClienti;
    regali;
    constructor() {
        this.totale = null;
        this.freezati = null;
        this.nonPiuClienti = null;
        this.regali = null;
    }
}
export class StoricoClienteVm {
    transactions;
    tasks;
    constructor() {
        this.transactions = [];
        this.tasks = [];
    }
}
export class TaskWithModificheVm {
    taskName;
    taskDate;
    modificheHistory;
    creditPrice;
    product;
    constructor() {
        this.taskName = "";
        this.taskDate = null;
        this.modificheHistory = [];
        this.creditPrice = null;
        this.product = "";
    }
}
export class DateText {
    date;
    text;
    constructor() {
        this.date = null;
        this.text = "";
    }
}
export class NewClientiStatVm {
    clienti;
    lead;
    constructor() {
        this.clienti = null;
        this.lead = null;
    }
}
export class CustomerServiceTableVm {
    identifier;
    createdOn;
    clienteOn;
    name;
    surname;
    cluster;
    email;
    source;
    credits;
    lastTaskOn;
    lastLoginOn;
    lastContact;
    richiestaPlanimetriaGratuitaOn;
    nonPiuClienteOn;
    rating;
    constructor() {
        this.identifier = "";
        this.createdOn = null;
        this.clienteOn = null;
        this.name = "";
        this.surname = "";
        this.cluster = "";
        this.email = "";
        this.source = "";
        this.credits = new CreditsDictionary();
        this.lastTaskOn = null;
        this.lastLoginOn = null;
        this.lastContact = null;
        this.richiestaPlanimetriaGratuitaOn = null;
        this.nonPiuClienteOn = null;
        this.rating = null;
    }
}
export class CreateCustomerChildVm {
    parentIdentifier;
    name;
    surname;
    email;
    password;
    constructor() {
        this.parentIdentifier = "";
        this.name = "";
        this.surname = "";
        this.email = "";
        this.password = "";
    }
}
export class MapMarker {
    title;
    position;
    constructor() {
        this.title = "";
        this.position = new MarkerPosition();
    }
}
export class MarkerPosition {
    lat;
    lng;
    constructor() {
        this.lat = null;
        this.lng = null;
    }
}
export class AddCreditVm {
    customerIdentifier;
    credits;
    transactionPrice;
    countAsFirstBuy;
    constructor() {
        this.customerIdentifier = "";
        this.credits = new CreditsDictionary();
        this.transactionPrice = null;
        this.countAsFirstBuy = false;
    }
}
export class LoginResponse {
    userIdentifier;
    createdOn;
    token;
    name;
    surname;
    qualifica;
    role;
    email;
    firmaEmail;
    preferredCulture;
    isFreezed;
    constructor() {
        this.userIdentifier = "";
        this.createdOn = null;
        this.token = "";
        this.name = "";
        this.surname = "";
        this.qualifica = "";
        this.role = "";
        this.email = "";
        this.firmaEmail = "";
        this.preferredCulture = "";
        this.isFreezed = false;
    }
}
export class RegisterCustomerVm {
    name;
    surname;
    agenzia;
    telefono;
    email;
    password;
    constructor() {
        this.name = "";
        this.surname = "";
        this.agenzia = "";
        this.telefono = "";
        this.email = "";
        this.password = "";
    }
}
export class LoginVm {
    email;
    password;
    constructor() {
        this.email = "";
        this.password = "";
    }
}
export class PasswordResetVm {
    email;
    token;
    newPassword;
    constructor() {
        this.email = "";
        this.token = "";
        this.newPassword = "";
    }
}
export class MailTemplate extends BaseEntity {
    templateName;
    eventName;
    subject;
    displaySubject;
    htmlContent;
    displayHtmlContent;
    constructor() {
        super();
        this.templateName = "";
        this.eventName = "";
        this.subject = "";
        this.displaySubject = new LocalizedText();
        this.htmlContent = "";
        this.displayHtmlContent = new LocalizedText();
    }
}
export class LocalizedText {
    values;
    constructor() {
        this.values = {};
    }
}
export class SendEmailVm {
    email;
    fromMail;
    subject;
    htmlContent;
    mailTemplateName;
    constructor() {
        this.email = "";
        this.fromMail = "";
        this.subject = "";
        this.htmlContent = "";
        this.mailTemplateName = "";
    }
}
export class DrawingVmForList {
    createdOn;
    modifiedOn;
    identifier;
    title;
    user;
    constructor() {
        this.createdOn = null;
        this.modifiedOn = null;
        this.identifier = "";
        this.title = "";
        this.user = new NameIdentifier();
    }
}
export class PlaniDesignerFile extends BaseEntity {
    title;
    elements;
    user;
    constructor() {
        super();
        this.title = "";
        this.elements = [];
        this.user = new NameIdentifier();
    }
}
export class Portafoglio extends BaseEntity {
    customerIdentifier;
    credits;
    constructor() {
        super();
        this.customerIdentifier = "";
        this.credits = new CreditsDictionary();
    }
}
export class Product extends BaseEntity {
    name;
    displayName;
    price;
    description;
    displayDescription;
    imageUrl;
    clusters;
    formUrl;
    order;
    daysForDueDate;
    disponibileGestim;
    gestimFormUrl;
    postOrder;
    tabellaCompensi;
    tabellaProvvigioniCommerciali;
    constructor() {
        super();
        this.name = "";
        this.displayName = new LocalizedText();
        this.price = null;
        this.description = "";
        this.displayDescription = new LocalizedText();
        this.imageUrl = "";
        this.clusters = [];
        this.formUrl = "";
        this.order = null;
        this.daysForDueDate = null;
        this.disponibileGestim = false;
        this.gestimFormUrl = "";
        this.postOrder = new PostOrder();
        this.tabellaCompensi = {};
        this.tabellaProvvigioniCommerciali = {};
    }
}
export class PostOrder {
    usePostOrder;
    htmlContent;
    displayHtmlContent;
    upsellProducts;
    deliveryOptions;
    constructor() {
        this.usePostOrder = false;
        this.htmlContent = "";
        this.displayHtmlContent = new LocalizedText();
        this.upsellProducts = [];
        this.deliveryOptions = [];
    }
}
export class UpsellProduct {
    name;
    displayName;
    description;
    displayDescription;
    imageUrl;
    price;
    priceWithVat;
    constructor() {
        this.name = "";
        this.displayName = new LocalizedText();
        this.description = "";
        this.displayDescription = new LocalizedText();
        this.imageUrl = "";
        this.price = null;
        this.priceWithVat = null;
    }
}
export class DeliveryOption {
    identifier;
    title;
    price;
    priceWithVat;
    commissionForAgent;
    visibleOnDays;
    descriptions;
    constructor() {
        this.identifier = "";
        this.title = "";
        this.price = null;
        this.priceWithVat = null;
        this.commissionForAgent = null;
        this.visibleOnDays = [];
        this.descriptions = [];
    }
}
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek[DayOfWeek["Sunday"] = 0] = "Sunday";
    DayOfWeek[DayOfWeek["Monday"] = 1] = "Monday";
    DayOfWeek[DayOfWeek["Tuesday"] = 2] = "Tuesday";
    DayOfWeek[DayOfWeek["Wednesday"] = 3] = "Wednesday";
    DayOfWeek[DayOfWeek["Thursday"] = 4] = "Thursday";
    DayOfWeek[DayOfWeek["Friday"] = 5] = "Friday";
    DayOfWeek[DayOfWeek["Saturday"] = 6] = "Saturday";
})(DayOfWeek || (DayOfWeek = {}));
export class DeilveryOptionDescription {
    description;
    fromTime;
    toTime;
    constructor() {
        this.description = "";
        this.fromTime = "";
        this.toTime = "";
    }
}
export class AutoDictionaryOfAutoDictionaryOfDecimal {
    item;
    constructor() {
        this.item = {};
    }
}
export class AutoDictionaryOfDecimal {
    item;
    constructor() {
        this.item = null;
    }
}
export class AutoDictionaryOfPercentualeCommerciali {
    item;
    constructor() {
        this.item = new PercentualeCommerciali();
    }
}
export class PercentualeCommerciali {
    primoAcquisto;
    successivi;
    constructor() {
        this.primoAcquisto = null;
        this.successivi = null;
    }
}
export class DeliveryOptionVm {
    identifier;
    title;
    description;
    price;
    priceWithVat;
    constructor() {
        this.identifier = "";
        this.title = "";
        this.description = "";
        this.price = null;
        this.priceWithVat = null;
    }
}
export class BuyPostOrderVm {
    token;
    productIdentifier;
    deliveryOptionIdentifier;
    upsellProductName;
    customerIdentifier;
    constructor() {
        this.token = "";
        this.productIdentifier = "";
        this.deliveryOptionIdentifier = "";
        this.upsellProductName = "";
        this.customerIdentifier = "";
    }
}
export class Referral extends BaseEntity {
    name;
    surname;
    email;
    telephone;
    stato;
    referrer;
    note;
    constructor() {
        super();
        this.name = "";
        this.surname = "";
        this.email = "";
        this.telephone = "";
        this.stato = "";
        this.referrer = new NameIdentifier();
        this.note = "";
    }
}
export class RegistroAccessi extends BaseEntity {
    customer;
    constructor() {
        super();
        this.customer = new NameIdentifier();
    }
}
export class RiepilogoGiornalieroVm {
    identifier;
    date;
    createdBy;
    constructor() {
        this.identifier = "";
        this.date = null;
        this.createdBy = new NameIdentifier();
    }
}
export class RiepilogoGiornaliero extends BaseEntity {
    date;
    nuoviLead;
    nuoviPacchettiRegalo;
    nuoviClienti;
    clientiPersi;
    assegnatiAdAssunti;
    totaleCreditiUtilizzati;
    taskAssegnati;
    taskAltri;
    taskAperti;
    modificheTask;
    rivendite;
    fatturatoTransazioni;
    createdBy;
    accessiGiornalieri;
    constructor() {
        super();
        this.date = null;
        this.nuoviLead = null;
        this.nuoviPacchettiRegalo = null;
        this.nuoviClienti = null;
        this.clientiPersi = null;
        this.assegnatiAdAssunti = [];
        this.totaleCreditiUtilizzati = null;
        this.taskAssegnati = null;
        this.taskAltri = null;
        this.taskAperti = null;
        this.modificheTask = null;
        this.rivendite = null;
        this.fatturatoTransazioni = null;
        this.createdBy = new NameIdentifier();
        this.accessiGiornalieri = null;
    }
}
export class NameNumberPair {
    name;
    identifier;
    number;
    constructor() {
        this.name = "";
        this.identifier = "";
        this.number = null;
    }
}
export class ShopOffer extends BaseEntity {
    name;
    displayName;
    description;
    displayDescription;
    imageUrl;
    bigImageUrl;
    clusters;
    order;
    options;
    disabledOn;
    constructor() {
        super();
        this.name = "";
        this.displayName = new LocalizedText();
        this.description = "";
        this.displayDescription = new LocalizedText();
        this.imageUrl = "";
        this.bigImageUrl = "";
        this.clusters = [];
        this.order = null;
        this.options = [];
        this.disabledOn = null;
    }
}
export class ShopOfferOption {
    credits;
    name;
    displayName;
    priceBarrato;
    price;
    priceWithVat;
    constructor() {
        this.credits = new CreditsDictionary();
        this.name = "";
        this.displayName = new LocalizedText();
        this.priceBarrato = "";
        this.price = null;
        this.priceWithVat = null;
    }
}
export class BuyOfferVm {
    token;
    shopOfferIdentifier;
    optionName;
    customerIdentifier;
    constructor() {
        this.token = "";
        this.shopOfferIdentifier = "";
        this.optionName = "";
        this.customerIdentifier = "";
    }
}
export class ShopOfferGestim extends BaseEntity {
    name;
    description;
    imageUrl;
    clusters;
    order;
    options;
    constructor() {
        super();
        this.name = "";
        this.description = "";
        this.imageUrl = "";
        this.clusters = [];
        this.order = null;
        this.options = [];
    }
}
export class StripeCardDetailVm {
    cardId;
    brand;
    country;
    currency;
    expMonth;
    expYear;
    dynamicLast4;
    last4;
    holder;
    constructor() {
        this.cardId = "";
        this.brand = "";
        this.country = "";
        this.currency = "";
        this.expMonth = null;
        this.expYear = null;
        this.dynamicLast4 = "";
        this.last4 = "";
        this.holder = "";
    }
}
export class StripeSaveCardVm {
    customerIdentifier;
    paymentMethodId;
    constructor() {
        this.customerIdentifier = "";
        this.paymentMethodId = "";
    }
}
export class TaskTrelloCollaboratoriVm {
    todo;
    working;
    waiting;
    concluded;
    constructor() {
        this.todo = [];
        this.working = [];
        this.waiting = [];
        this.concluded = [];
    }
}
export class TaskTableVm {
    identifier;
    product;
    title;
    customer;
    userAssigned;
    startDate;
    dueDate;
    lastState;
    compenso;
    compensoExtra;
    creditPrice;
    priorita;
    deliveryOption;
    deliveryAttachments;
    constructor() {
        this.identifier = "";
        this.product = new NameIdentifier();
        this.title = "";
        this.customer = new NameIdentifier();
        this.userAssigned = new NameIdentifierDate();
        this.startDate = null;
        this.dueDate = null;
        this.lastState = new DateText();
        this.compenso = null;
        this.compensoExtra = null;
        this.creditPrice = null;
        this.priorita = false;
        this.deliveryOption = new DeliveryOption();
        this.deliveryAttachments = [];
    }
}
export class NameIdentifierDate extends NameIdentifier {
    date;
    constructor() {
        super();
        this.date = null;
    }
}
export class TaskTrelloVm {
    groupName;
    user;
    tasks;
    constructor() {
        this.groupName = "";
        this.user = new NameIdentifier();
        this.tasks = [];
    }
}
export class TaskTableResponseVm {
    totalTasks;
    totalCrediti;
    averageCompenso;
    totalCompenso;
    data;
    constructor() {
        this.totalTasks = null;
        this.totalCrediti = null;
        this.averageCompenso = null;
        this.totalCompenso = null;
        this.data = [];
    }
}
export class GetTaskTableFilterVm {
    showConcluded;
    officeIdentifier;
    userIdentifier;
    fromDate;
    toDate;
    constructor() {
        this.showConcluded = false;
        this.officeIdentifier = "";
        this.userIdentifier = "";
        this.fromDate = null;
        this.toDate = null;
    }
}
export class Task extends BaseEntity {
    product;
    uid;
    creditPrice;
    title;
    priorita;
    deveSeguireLeFoto;
    description;
    startDate;
    dueDate;
    endDate;
    stateHistory;
    modificheHistory;
    customer;
    requestAttachments;
    officeIdentifier;
    compenso;
    metriQuadri;
    showDeliveryAttachments;
    userAssigned;
    deliveryAttachments;
    transactionIdentifier;
    gestimRequestIdentifier;
    deliveryOption;
    postOrderTask;
    metaData;
    qualitaTask;
    standByTask;
    constructor() {
        super();
        this.product = new NameIdentifier();
        this.uid = null;
        this.creditPrice = null;
        this.title = "";
        this.priorita = false;
        this.deveSeguireLeFoto = false;
        this.description = "";
        this.startDate = null;
        this.dueDate = null;
        this.endDate = null;
        this.stateHistory = [];
        this.modificheHistory = [];
        this.customer = new NameIdentifier();
        this.requestAttachments = [];
        this.officeIdentifier = "";
        this.compenso = null;
        this.metriQuadri = null;
        this.showDeliveryAttachments = false;
        this.userAssigned = new NameIdentifierDate();
        this.deliveryAttachments = [];
        this.transactionIdentifier = "";
        this.gestimRequestIdentifier = "";
        this.deliveryOption = new DeliveryOption();
        this.postOrderTask = new PostOrderTask();
        this.metaData = {};
        this.qualitaTask = new QualitaTask();
        this.standByTask = new StandByTask();
    }
}
export class PostOrderTask {
    name;
    constructor() {
        this.name = "";
    }
}
export class QualitaTask {
    erroreLeggero;
    erroreGrave;
    erroreDoppio;
    erroreCliente;
    hasExtraCompenso;
    extraCompensoAmount;
    constructor() {
        this.erroreLeggero = false;
        this.erroreGrave = false;
        this.erroreDoppio = false;
        this.erroreCliente = false;
        this.hasExtraCompenso = false;
        this.extraCompensoAmount = null;
    }
}
export class StandByTask {
    planimetriaNonScalabile;
    mancanoIndicazioniDisposizione;
    mancanoDestinazioniDuso;
    planimetriaScansionataMale;
    mancaIlGiardino;
    mancanoFiniture;
    altro;
    altroText;
    constructor() {
        this.planimetriaNonScalabile = false;
        this.mancanoIndicazioniDisposizione = false;
        this.mancanoDestinazioniDuso = false;
        this.planimetriaScansionataMale = false;
        this.mancaIlGiardino = false;
        this.mancanoFiniture = false;
        this.altro = false;
        this.altroText = "";
    }
}
export class AssignTaskVm {
    taskIdentifier;
    userIdentifier;
    constructor() {
        this.taskIdentifier = "";
        this.userIdentifier = "";
    }
}
export class TaskVm {
    identifier;
    product;
    creditPrice;
    title;
    startDate;
    dueDate;
    endDate;
    lastState;
    deliveryAttachmentsCount;
    showDeliveryAttachments;
    deliveryOption;
    postOrder;
    constructor() {
        this.identifier = "";
        this.product = new NameIdentifier();
        this.creditPrice = null;
        this.title = "";
        this.startDate = null;
        this.dueDate = null;
        this.endDate = null;
        this.lastState = new DateText();
        this.deliveryAttachmentsCount = null;
        this.showDeliveryAttachments = false;
        this.deliveryOption = new DeliveryOption();
        this.postOrder = new PostOrderTask();
    }
}
export class TaskStatVm {
    prodotto;
    created;
    modificheRichieste;
    creditiUsati;
    constructor() {
        this.prodotto = "";
        this.created = null;
        this.modificheRichieste = null;
        this.creditiUsati = null;
    }
}
export class GestimRequest extends BaseEntity {
    id_richiesta;
    url_foto;
    url_planimetrie;
    title;
    constructor() {
        super();
        this.id_richiesta = "";
        this.url_foto = [];
        this.url_planimetrie = [];
        this.title = "";
    }
}
export class ExportTaskFilterVm {
    clienteParentIdentifier;
    customerIdentifier;
    dateFrom;
    dateTo;
    constructor() {
        this.clienteParentIdentifier = "";
        this.customerIdentifier = "";
        this.dateFrom = null;
        this.dateTo = null;
    }
}
export class RiepilogoAttivitaClienteVm {
    cliente;
    agenzia;
    taskAperti;
    totaleCreditiDisponibili;
    fatturatoPerAnno;
    constructor() {
        this.cliente = new NameIdentifier();
        this.agenzia = "";
        this.taskAperti = null;
        this.totaleCreditiDisponibili = null;
        this.fatturatoPerAnno = {};
    }
}
export class RiepilogoStandByTaskVm {
    planimetriaNonScalabile;
    mancanoIndicazioniDisposizione;
    mancanoDestinazioniDuso;
    planimetriaScansionataMale;
    mancaIlGiardino;
    mancanoFiniture;
    altro;
    constructor() {
        this.planimetriaNonScalabile = null;
        this.mancanoIndicazioniDisposizione = null;
        this.mancanoDestinazioniDuso = null;
        this.planimetriaScansionataMale = null;
        this.mancaIlGiardino = null;
        this.mancanoFiniture = null;
        this.altro = null;
    }
}
export class RiepilogoErroriArchitettiVm {
    architetto;
    totaleTask;
    totaleHaSeguitoLeFoto;
    perfette;
    qualitaTaskCounter;
    totaleCrediti;
    totaleCompenso;
    totaleCompensoPerModifiche;
    totaleCompensoPerDelivery;
    task0Metri;
    task50Metri;
    task50100Metri;
    task100150Metri;
    task150200Metri;
    task200Metri;
    constructor() {
        this.architetto = new NameIdentifier();
        this.totaleTask = null;
        this.totaleHaSeguitoLeFoto = null;
        this.perfette = null;
        this.qualitaTaskCounter = new QualitaTaskCounter();
        this.totaleCrediti = null;
        this.totaleCompenso = null;
        this.totaleCompensoPerModifiche = null;
        this.totaleCompensoPerDelivery = null;
        this.task0Metri = null;
        this.task50Metri = null;
        this.task50100Metri = null;
        this.task100150Metri = null;
        this.task150200Metri = null;
        this.task200Metri = null;
    }
}
export class QualitaTaskCounter {
    erroreLeggero;
    erroreGrave;
    erroreDoppio;
    erroreCliente;
    constructor() {
        this.erroreLeggero = null;
        this.erroreGrave = null;
        this.erroreDoppio = null;
        this.erroreCliente = null;
    }
}
export class User extends BaseEntity {
    name;
    email;
    password;
    telephone;
    role;
    resetPasswordToken;
    order;
    firmaEmail;
    isAssunto;
    isAddettoRivendite;
    qualificaCommerciale;
    qualifica;
    storicoQualifiche;
    disabledOn;
    datiPerRitenuta;
    constructor() {
        super();
        this.name = "";
        this.email = "";
        this.password = "";
        this.telephone = "";
        this.role = "";
        this.resetPasswordToken = "";
        this.order = null;
        this.firmaEmail = "";
        this.isAssunto = false;
        this.isAddettoRivendite = false;
        this.qualificaCommerciale = "";
        this.qualifica = "";
        this.storicoQualifiche = [];
        this.disabledOn = null;
        this.datiPerRitenuta = new DatiPerRitenuta();
    }
}
export class DatiPerRitenuta {
    nome;
    cognome;
    codiceFiscale;
    iban;
    intestazioneConto;
    constructor() {
        this.nome = "";
        this.cognome = "";
        this.codiceFiscale = "";
        this.iban = "";
        this.intestazioneConto = "";
    }
}
export class NameIdentifierQualifica extends NameIdentifier {
    qualifica;
    constructor() {
        super();
        this.qualifica = "";
    }
}
export class SaveUsersOrderVm {
    user;
    order;
    constructor() {
        this.user = new NameIdentifier();
        this.order = null;
    }
}
export class SpesaCollaboratoriVm {
    name;
    amount;
    constructor() {
        this.name = "";
        this.amount = null;
    }
}
export class RichiestaPagamento extends BaseEntity {
    user;
    nazione;
    importoLordo;
    importoNetto;
    sentOn;
    useRitenutaAcconto;
    datiRitenutaAcconto;
    gestitaOn;
    constructor() {
        super();
        this.user = new NameIdentifier();
        this.nazione = "";
        this.importoLordo = null;
        this.importoNetto = null;
        this.sentOn = null;
        this.useRitenutaAcconto = false;
        this.datiRitenutaAcconto = new DatiRitenutaAcconto();
        this.gestitaOn = null;
    }
}
export class RichiestaPagamentoCommerciale extends RichiestaPagamento {
    transactionList;
    constructor() {
        super();
        this.transactionList = [];
    }
}
export class DatiRitenutaAcconto {
    dataRitenuta;
    nomeUtente;
    luogoNascita;
    indirizzoResidenza;
    codiceFiscale;
    iban;
    intestatarioConto;
    importoLordo;
    importoRitenuta;
    importoNetto;
    constructor() {
        this.dataRitenuta = "";
        this.nomeUtente = "";
        this.luogoNascita = "";
        this.indirizzoResidenza = "";
        this.codiceFiscale = "";
        this.iban = "";
        this.intestatarioConto = "";
        this.importoLordo = "";
        this.importoRitenuta = "";
        this.importoNetto = "";
    }
}
export class PagamentoCommercialeRequestVm {
    creditTransactionsList;
    user;
    useRitenutaAcconto;
    datiRitenutaAcconto;
    constructor() {
        this.creditTransactionsList = [];
        this.user = new NameIdentifier();
        this.useRitenutaAcconto = false;
        this.datiRitenutaAcconto = new DatiRitenutaAcconto();
    }
}
export class RichiestaPagamentoUser extends RichiestaPagamento {
    taskList;
    constructor() {
        super();
        this.taskList = [];
    }
}
export class PagamentoUserRequestVm {
    tasksList;
    user;
    useRitenutaAcconto;
    datiRitenutaAcconto;
    constructor() {
        this.tasksList = [];
        this.user = new NameIdentifier();
        this.useRitenutaAcconto = false;
        this.datiRitenutaAcconto = new DatiRitenutaAcconto();
    }
}
